import { Box, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "shared/lib/hooks/hooks";
import { serverURL } from "shared/lib/serverURL";

const Partners = () => {
  const { t } = useTranslation();
  const marathon = useAppSelector(
    (state) => state.marathons.marathonsById.response.data
  );

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#0090D1",
          paddingBottom: "20px",
        }}
      >
        {t("myMarathon.partners")}
      </Typography>

      {marathon?.partners?.map((partner) => (
        <Box key={partner.id} sx={{ marginBottom: "24px" }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 600,
              marginBottom: "12px",
            }}
          >
            {partner.name}
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {partner.partnerCompanies?.map((company) => (
              <Box
                key={company.id}
                sx={{
                  width: "120px",
                  height: "92px",
                  borderRadius: "16px",
                  padding: "4px",
                  border: "2px solid #ECF2F7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                }}
              >
                <a
                  href={company.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{ display: "flex", width: "100%", height: "100%" }}
                >
                  <img
                    src={`${serverURL}${company.logo}`}
                    alt={company.name}
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      borderRadius: "12px",
                    }}
                  />
                </a>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Paper>
  );
};

export default Partners;
